/**
 * Created by razial on 12.10.2021
 */

const MissionTree = function (unit) {
    UnitComponent.call(this, unit);

    this.missionType = Mission.CompoundType(unit.getData().mission, cleverapps.meta.selectedLocationId());

    this.nextStage = unit.stage;
    this.multiline = false;
    this.current = false;

    if (cleverapps.config.adminMode) {
        return;
    }

    if (!MissionTree.targets[this.missionType]) {
        MissionTree.targets[this.missionType] = [];
    }

    MissionTree.targets[this.missionType].push(this);

    let mission = this.getMission();

    if (!mission && MissionManager.hasProperLocation(this.missionType)) {
        cleverapps.missionManager.manualStart(this.missionType, {
            fromMissionTree: true
        });
        mission = cleverapps.missionManager.findByType(this.missionType);
    }

    const logic = mission && mission.logic;
    if (logic) {
        if (logic.onLevelChangedListeners && logic.onUpdateListeners && logic.onProgressChangedListeners) {
            logic.onLevelChangedListeners[this.unit.code] = this.onMissionLevelChanged.bind(this);
            logic.onUpdateListeners[this.unit.code] = this.onUpdatePrizes.bind(this);
            logic.onProgressChangedListeners[this.unit.code] = this.onUpdateState.bind(this);
        }

        this.onMissionLevelChanged();
        this.onUpdatePrizes();
    }
};

MissionTree.prototype = Object.create(UnitComponent.prototype);
MissionTree.prototype.constructor = MissionTree;

MissionTree.prototype.getView = function () {
    return this.view;
};

MissionTree.prototype.onCreate = function () {
    if (this.view) {
        this.view.onCreate();
    }
};

MissionTree.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

MissionTree.prototype.getMission = function () {
    return cleverapps.missionManager.findByType(this.missionType);
};

MissionTree.prototype.destructor = function () {
    const mission = this.getMission();
    const logic = mission && mission.logic;

    if (logic) {
        if (logic.onLevelChangedListeners && logic.onUpdateListeners && logic.onProgressChangedListeners) {
            logic.onLevelChangedListeners[this.unit.code] = function () {};
            logic.onUpdateListeners[this.unit.code] = function () {};
            logic.onProgressChangedListeners[this.unit.code] = function () {};
        }
    }

    const targets = MissionTree.targets[this.missionType];
    if (targets) {
        const index = targets.indexOf(this);
        if (index !== -1) {
            targets.splice(index, 1);
        }
    }
};

MissionTree.prototype.calcState = function () {
    const codes = cleverapps.unitsLibrary.listCodesByType(this.unit.getType(), cleverapps.meta.selectedLocationId());
    const state = {
        stage: this.unit.stage,
        multiline: codes.length > 1
    };

    const mission = this.getMission();
    if (!mission || !mission.isPassMission()) {
        return state;
    }

    let level = 0;

    for (let i = 0; i < codes.length; ++i) {
        const code = codes[i];
        const units = UnitsLibrary.ListByCode(code);
        const total = units.length - 1;

        if (code !== this.unit.code) {
            level += total;
            continue;
        }

        const nextStage = mission.logic.shownProgress.level - level;
        if (nextStage < 0) {
            state.stage = units[0].stage;
        } else if (nextStage >= total) {
            state.stage = units[total].stage;
        } else {
            state.stage = units[nextStage].stage;
            state.current = true;
        }

        return state;
    }
};

MissionTree.prototype.showHint = function () {
    if (this.isCurrentTree()) {
        cleverapps.centerHint.create({
            currentTree: this.unit
        });
        return;
    }

    const current = Map2d.currentMap.listAvailableUnits((unit) => {
        const missionTree = unit.findComponent(MissionTree);
        return missionTree && missionTree.isCurrentTree() && missionTree.missionType === this.missionType;
    })[0];

    if (!current) {
        if (!this.unit.isLast()) {
            cleverapps.centerHint.createTextHint(Messages.get("MissionTree.hint.notStarted"));
        } else {
            cleverapps.centerHint.createTextHint(Messages.get("MissionTree.hint.notfound"));
        }
        return;
    }

    cleverapps.centerHint.create(this.unit.isLast() ? {
        nextTree: current
    } : {
        previousTree: current
    });

    FingerView.hintTap({ x: current.x, y: current.y }, { runOnce: true });
    Map2d.currentMap.focusOnUnit(current, {
        allowScrollWithFocus: true
    });
};

MissionTree.prototype.onMissionLevelChanged = function () {
    const state = this.calcState();
    this.nextStage = state.stage;
    this.current = state.current;
    this.multiline = state.multiline;
    MissionTree.wantsToUpdateUnitStage = true;
    this.onUpdateState();
};

MissionTree.prototype.wantsChangeStage = function () {
    return this.nextStage !== this.unit.stage;
};

MissionTree.prototype.changeStage = function () {
    if (!this.wantsChangeStage()) {
        return;
    }

    const view = this.view;

    this.unit.remove(true);

    const newUnit = new Unit({
        code: this.unit.code,
        stage: this.nextStage
    });
    newUnit.setPosition(this.unit.x, this.unit.y);
    Map2d.currentMap.onUnitAvailable(newUnit);
    Map2d.currentMap.onAddUnit(newUnit.x, newUnit.y, newUnit);

    let newMissionTree;
    if (view) {
        newMissionTree = newUnit.findComponent(MissionTree);
        newMissionTree.getView().onUpgrade(view);
    }

    return newMissionTree;
};

MissionTree.prototype.isCurrentTree = function () {
    return !this.multiline || this.current;
};

MissionTree.prototype.needsProgress = function () {
    return this.current;
};

MissionTree.prototype.needsHelp = function () {
    return this.multiline && this.current;
};

MissionTree.prototype.calcPercent = function () {
    const mission = this.getMission();
    if (mission.logic.progress.level > mission.logic.shownProgress.level || !mission.logic.levels[mission.logic.progress.level]) {
        return 100;
    }
    if (mission.logic.progress.level < mission.logic.shownProgress.level) {
        return 0;
    }
    return mission.logic.progress.progress / mission.logic.levels[mission.logic.progress.level].task.goal * 100;
};

MissionTree.prototype.spawnPrizes = function () {
    const pageId = cleverapps.meta.selectedLocationId();
    if (MissionTree.PRIZES[pageId]) {
        const amountFree = Map2d.currentMap.countEmptySlots();
        const prizes = Prizes.Generate(MissionTree.PRIZES[pageId]).slice(0, amountFree);
        if (prizes.length) {
            Map2dLocation.currentLocation.spawn(prizes, this.unit, { radius: Map2d.RADIUS_SMALL, spawnSource: "missiontree" });
            return true;
        }
    }
};

MissionTree.prototype.handlePrizes = function () {
    this.handleClick();

    return true;
};

MissionTree.prototype.onUpdatePrizes = function () {
    const mission = this.getMission();
    if (mission && mission.logic && mission.logic.countAvailableRewards && mission.logic.countAvailableRewards() > 0 && this.isCurrentTree()) {
        this.unit.setPrizes({ sprite: bundles.merge.frames.prize_exclamation });
    } else {
        this.unit.setPrizes();
    }
};

MissionTree.prototype.handleClick = function () {
    const mission = this.getMission();
    if (!mission || !mission.isRunning()) {
        cleverapps.centerHint.createTextHint(Messages.get(`MissionNotStarted.${Missions[this.missionType].name}`));
        return false;
    }

    this.unit.squeeze();
    cleverapps.effects.fire("ui.button.click");

    if (!this.isCurrentTree()) {
        this.showHint();
        return true;
    }

    cleverapps.focusManager.display({
        stack: Map2dLocation.currentLocation.tutorial.checkConditions({ unit: this.unit }) || cleverapps.tutorial.checkConditions({ unit: this.unit }),
        focus: "missionWindow",
        actions: [
            function (f) {
                cleverapps.timeouts.setTimeout(f, 300);
            },

            function (f) {
                mission.needShowStartWindow = false;

                const ViewClass = mission.getViewClass();
                new ViewClass(mission);

                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            function (f) {
                f();
                Map2d.mapEvent(Map2d.MISSION_TREE_CLOSED, { affected: this.unit });
            }.bind(this)
        ]
    });

    return true;
};

MissionTree.findReadyForUpdateUnit = function () {
    for (const missionType in MissionTree.targets) {
        const targets = MissionTree.targets[missionType];
        if (!targets.length) {
            continue;
        }

        for (let i = 0; i < targets.length; ++i) {
            const missionTree = targets[i];

            if (Map2d.currentMap.getUnit(missionTree.unit.x, missionTree.unit.y) !== missionTree.unit) {
                continue;
            }

            if (missionTree.wantsChangeStage()) {
                return missionTree;
            }
        }
    }
};

MissionTree.processStateChange = function () {
    const missionTree = MissionTree.findReadyForUpdateUnit();
    if (!missionTree) {
        MissionTree.wantsToUpdateUnitStage = false;
        return;
    }

    const scrollCell = Map2d.currentMap.scroller.scrollCell;

    cleverapps.focusManager.display({
        focus: "updateBuildPassUnit",
        actions: [
            function (f) {
                Map2d.currentMap.focusOnUnit(missionTree.unit, {
                    allowScrollWithFocus: true,
                    callback: f
                });
            },

            function (f) {
                const newMissionTree = missionTree.changeStage();
                if (newMissionTree) {
                    cleverapps.timeouts.setTimeout(f, 2000);
                } else {
                    f();
                }
            },

            function (f) {
                if (missionTree.spawnPrizes()) {
                    cleverapps.timeouts.setTimeout(f, 1100);
                } else {
                    f();
                }
            },

            function (f) {
                if (scrollCell) {
                    Map2d.currentMap.focusOnUnit(scrollCell, {
                        allowScrollWithFocus: true,
                        callback: f
                    });
                }
            }
        ]
    });
};

MissionTree.targets = {};

MissionTree.PRIZES = {};
